import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import moment from "moment";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import "react-datepicker/dist/react-datepicker.css";

// react component for creating dynamic tables
// @material-ui/core components
// import SweetAlert from "react-bootstrap-sweetalert";

// import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
import { useTranslation } from "react-i18next";
import Review from "components/Profile/Review.js";

import getReviews from "api/review/getReview.js";

const useStyles = makeStyles(styles);

export default function UserReviews(props) {
  const [reviews, setReviews] = useState([]);
  const user = props.user; //&& props.user.userDataId ? props.user.userDataId : {};
  useEffect(() => {
    console.log("entor qiu", props.user);
    if (props.user && props.user._id) {
      console.log("entro anche quiiiiii");
      getReviews(user._id, 3, reviews.length)
        .then(res => {
          let rev = [];
          console.log("res", res);
          if (res && res.length > 0) {
            rev = [].concat(reviews).concat(res);
          }
          setReviews(rev);
        })
        .catch(err => console.log("err", err));
    }
  }, [user]);
  // useEffect(()=> {
  //
  // },[user])
  // TODO should component update con questo sotto
  // useMemo(user => {
  //   console.log("entor qiu 2", props.user);
  //   if (props.user && props.user._id) {
  //     console.log("entro anche quiiiiii 2");
  //     getReviews(user._id, 3, reviews.length)
  //       .then(res => {
  //         console.log("res", res);
  //         if (res && res.reviews && res.reviews.length > 0) {
  //           reviews.push(res.reviews);
  //         }
  //         setReviews(reviews);
  //       })
  //       .catch(err => console.log("err", err));
  //   }
  // }, []);
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  console.log("user", user);

  const showMoreResults = () => {
    getReviews(user._id, 3, reviews.length)
      .then(res => {
        let rev = [];
        console.log("res", res);
        if (res && res.length > 0) {
          rev = [].concat(reviews).concat(res);
        }
        setReviews(rev);
      })
      .catch(err => console.log("err", err));
  };

  return (
    <div className="main-banner-home">
      <div className="user-data-title">
        {/* {user.reviewNumber && user.reviewNumber > 0 ? ( */}
        <span>{user.reviewNumber} Recensioni</span>
        {/*
          <span>Non ci sono ancora recensioni</span>
         */}
      </div>
      {reviews && reviews.length > 0 ? (
        <div className="user-activities-container">
          <div className="user-contents-reviews-container">
            {reviews.map((el, index) => {
              // console.log("review", el);
              let category = 10;
              if (props.attributes && props.attributes.categories) {
                category = props.attributes.categories.find(
                  elem => Number(elem._id) === Number(el.category)
                );
              }
              const review = {
                name: el.restaurantId.name,
                alias: el.restaurantId.alias,
                checkInNumber: el.restaurantId.checkInNumber,
                category,
                ownerReply: el.ownerReply,
                addressIT: el.restaurantId.addressIT,
                address: el.restaurantId.address,
                facebook: el.facebook,
                addressEN: el.restaurantId.addressEN,
                checkInDate: el.checkInDate,
                location: el.restaurantId.location,
                viewStyleSelected: el.restaurantId.viewStyleSelected,
                photo: el.restaurantId.photos,
                _id: el._id,
                score: el.score,
                price: el.price,
                text: el.blob || ""
              };
              return (
                <div
                  key={`user-reviews-${index.toString()}`}
                  className="user-contents-review-position"
                >
                  <Review review={review} attributes={props.attributes} />
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
      {reviews.length < user.reviewNumber ? (
        <div style={{ width: "100%", display: "flex" }}>
          <button
            className="show-more-results"
            style={{ margin: "30px auto" }}
            onClick={() => {
              showMoreResults();
            }}
          >
            Mostra altro
          </button>
        </div>
      ) : null}
    </div>
  );
}
UserReviews.propTypes = {
  updateCity: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  attributes: PropTypes.object.isRequired
};
